<template>
    <div class="md-layout">
        <div class="md-layout-item">
            <md-card v-if="!loadingState">
                <md-card-header class="md-card-header-icon md-card-header-primary">
                    <div class="card-icon">
                        <md-icon>store</md-icon>
                    </div>
                </md-card-header>
                <md-card-content>
                    <div class="md-layout md-gutter">
                        <div class="md-layout-item md-small-size-100">
                            <md-field>
                                <label>Name</label>
                                <md-input v-model="name" type="text"></md-input>
                            </md-field>
                        </div>
                        <div class="md-layout-item md-small-size-100">
                            <md-field>
                                <label>Email</label>
                                <md-input v-model="email" type="text"></md-input>
                            </md-field>
                        </div>
                        <div class="md-layout-item md-small-size-100">
                            <md-field>
                                <label> Timezone</label>
                                <md-select v-model="selectedTimezone" name="timezone" id="timezone">
                                    <md-option v-for="(timezone, index) in timezones" :key="index" v-bind:value="timezone.id">
                                        {{timezone.name}}
                                    </md-option>
                                </md-select>
                            </md-field>
                        </div>
                    </div>
                    <div class="md-layout md-gutter">
                        <div class="md-layout-item md-small-size-100">
                            <md-field>
                                <label>Address</label>
                                <md-input v-model="address" type="text"></md-input>
                            </md-field>
                        </div>
                        <div class="md-layout-item md-small-size-100 md-size-33">
                            <md-field>
                                <label>Subdomain</label>
                                <md-input v-model="subdomain" type="text"></md-input>
                            </md-field>
                        </div>
                    </div>
                    <md-switch v-model="isActive">Is active</md-switch>
                    <div class="md-title form-title-margin">Modules</div>
                    <div class="md-layout md-gutter">
                        <div v-for="(module, index) in modules" :key="index" class="md-layout-item md-small-size-100 md-medium-size-30 md-size-20">
                            <md-checkbox  v-model="selectedModules" v-bind:value="module.id"> {{module.name}} </md-checkbox>
                        </div>
                    </div>
                    <div class="md-title form-title-margin">Images</div>
                    <div class="md-layout md-gutter">
                        <div class="md-layout-item md-small-size-100">
                            <div>
                                <label>Logo</label>
                                <image-uploader
                                    :value="this.logoFile"
                                    @targetChanged="onLogoTargetChanged"
                                    @sourceChanged="onLogoSourceChanged" />
                            </div>
                            <div>
                                <label>Icon</label>
                                <image-uploader
                                    :value="this.iconFile"
                                    @targetChanged="onIconTargetChanged"
                                    @sourceChanged="onIconSourceChanged" />
                            </div>
                        </div>
                    </div>
                    <md-field>
                        <label>Page footer</label>
                        <md-textarea v-model="footer" type="text"></md-textarea>
                    </md-field>
                    <div class="md-title form-title-margin">Template</div>
                    <div class="md-layout md-gutter">
                        <div class="md-layout-item md-small-size-100">
                            <color-picker v-model="headerColour">
                                <label>Header</label>
                            </color-picker>
                        </div>
                        <div class="md-layout-item md-small-size-100">
                            <color-picker v-model="menuColour">
                                <label>Menu</label>
                            </color-picker>
                        </div>
                        <div class="md-layout-item md-small-size-100">
                            <color-picker v-model="footerColour">
                                <label>Footer</label>
                            </color-picker>
                        </div>
                    </div>
                    <div class="md-title form-title-margin"> Sidebar </div>
                    <div class="md-layout md-gutter">
                        <div class="md-layout-item md-small-size-100">
                            <md-radio v-for="(button, index) in radioButtons" v-model="sidebar" :key="index" v-bind:value="button.id">{{button.label}}</md-radio>
                        </div>
                    </div>
                    <md-switch v-model="layout">Boxed layout</md-switch>
                    <md-switch v-model="accordionMode">Accordion mode</md-switch>
                    <div class="user-update-actions">
                        <md-button class="md-simple" @click.native="actionCancel">Cancel</md-button>

                        <md-button class="md-primary" @click="actionSave(false)">{{createOrUpdateText}}
                        </md-button>
                    </div>
                </md-card-content>
            </md-card>
            <loader v-else class="color"/>
        </div>
    </div>
</template>

<script>
    import {mapMutations} from "vuex";
    import axios from 'axios';
    import AuthService from '../../services/AuthService';
    import ColorPicker from "../../components/Inputs/ColorPicker";
    import Loader from "../../../old/components/Loader";
    import ImageUploader from "@/new/components/ImageUploader";

    export default {
        name: "ResellerCreate",
        components: {ImageUploader, ColorPicker, Loader},
        computed: {
            createOrUpdateText(){
                return this.isUpdateMode? 'Update':'Create';
            },
            accessToken(){
                return AuthService.getAccessToken();
            },
          isUpdateMode(){
              return this.$route.params.id !== undefined;
          },
            loadingModulesAndTimezones(){
                return this.modules === [] || this.timezones === [];
            },
            loadingState(){
                if(this.isUpdateMode){
                    return this.loadingModulesAndTimezones || this.loadingReseller;
                }
                return this.loadingModulesAndTimezones;
            },
            pageTitle(){
                return this.isUpdateMode? 'Edit Reseller':'Create Reseller';
            }
        },
        data() {
            return {
                name: '',
                email: '',
                address: '',
                subdomain: '',
                layout: false,
                selectedTimezone: '',
                timezones: [],
                icon : null,
                iconFile: {},
                logo:  null,
                logoFile: {},
                footer: '',
                modules: [],
                selectedModules: [],
                headerColour: '#000000',
                menuColour: '#000000',
                footerColour: '#000000',
                accordionMode: false,
                radioButtons: [
                    {label: 'Normal', id: 'normal'},
                    {label: 'Mini', id: 'mini'},
                    {label: 'Slim', id: 'slim'}
                ],
                sidebar: 'normal',
                isActive: false,
                loadingReseller: true
            }
        },
        methods: {
            changeFooterColour(event) {
                this.footerColour = event.target.value;
            },
            onLogoTargetChanged(event) {
                this.logoFile = event;
            },
            onLogoSourceChanged(event) {
                this.logoFile = event;
                this.logo = null;
            },
            onIconTargetChanged(event) {
                this.iconFile = event;
            },
            onIconSourceChanged(event) {
                this.iconFile = event;
                this.icon = null;
            },
            changeMenuColour(event) {
                this.menuColour = event.target.value;
            },
            actionSave() {
                let data = {
                    name: this.name,
                    address: this.address,
                    email: this.email,
                    subdomain: this.subdomain,
                    time_zone_id : this.selectedTimezone,
                    page_footer: this.footer,
                    color_header: this.headerColour,
                    color_menu: this.menuColour,
                    color_footer: this.footerColour,
                    modules: this.selectedModules,
                    accordion_mode_main_menu: Number(this.accordionMode),
                    style_sidebar: this.sidebar,
                    style_layout_boxed: Number(this.layout),
                    active: Number(this.isActive),
                    logo: Number(this.logo),
                    icon: Number(this.icon)
                };

                let formData = new FormData();

                for(let key in data) {
                    formData.append(key, data[key]);
                }

                if (this.iconFile.sourceFile) {
                    formData.append('iconSource', this.iconFile.sourceFile, this.iconFile.name);
                }

                if (this.iconFile.targetFile) {
                    formData.append('iconTarget', this.iconFile.targetFile, this.iconFile.name);
                    formData.append('iconData', JSON.stringify(this.iconFile.data));
                }


                if (this.logoFile.sourceFile) {
                    formData.append('logoSource', this.logoFile.sourceFile, this.logoFile.name);
                }

                if (this.logoFile.targetFile) {
                    formData.append('logoTarget', this.logoFile.targetFile, this.logoFile.name);
                    formData.append('logoData', JSON.stringify(this.logoFile.data));
                }



                if(this.isUpdateMode){
                    this.loadingReseller = true;
                    axios.post(process.env.VUE_APP_API_URL + '/api/v1/hierarchy/reseller/' + this.$route.params.id, formData, {
                        headers: {"content-type": "multipart/form-data"}
                    }).then(({data}) => {
                        this.assignFields(data);
                    }).finally(() => {
                        this.loadingReseller = false;
                    });
                } else {
                    axios.post(process.env.VUE_APP_API_URL + '/api/v1/hierarchy/reseller/create', formData, {
                        headers: {"content-type": "multipart/form-data"}
                    }).then(() => {
                        this.$router.push(this.$enums.RoutePathEnum.RESELLERS);
                    });
                }
            },
            assignFields(data){
                this.name = data.model.name ?? '';
                this.email = data.model.email ?? '';
                this.address = data.model.address ?? '';
                this.subdomain = data.model.subdomain ?? '';
                this.selectedTimezone = data.model.time_zone_id ?? '';
                this.footer = data.model.page_footer ?? '';
                this.headerColour = data.model.color_header ?? '';
                this.menuColour = data.model.color_menu ?? '';
                this.footerColour = data.model.color_footer ?? '';
                this.selectedModules = data.model.modules ?? [];
                this.accordionMode = Boolean(data.model.accordion_mode_main_menu) ?? false;
                this.sidebar = data.model.style_sidebar ?? '';
                this.layout = Boolean(data.model.style_layout_boxed) ?? false;
                this.icon = data.model.icon;
                this.logo = data.model.logo;
                this.isActive = Boolean(data.model.active) ?? false;
                this.modules = data.options.modules ?? [];
                this.timezones = data.options.timeZone?? [];
                this.logoFile = data.options.logo;
                this.iconFile = data.options.icon;
                if (this.sidebar !== '') {
                    this.sidebar[0].toUpperCase();
                }
            },
            actionCancel() {
                this.$router.back();
            },
            loadResellerData(){
                this.loadingReseller = true;
                this.$api.resellerView({
                    segments: {
                        id: this.$route.params.id ?? -1,
                    }
                }).then(({data}) => {
                    this.assignFields(data);
                }).catch(() => {
                    this.$router.back();
                }).finally(()=>{
                    this.loadingReseller = false;
                });
            },
            clearResellerData(){
                this.name = '';
                this.email = '';
                this.address = '';
                this.subdomain = '';
                this.selectedTimezone = '';
                this.footer = '';
                this.headerColour = '#000000';
                this.menuColour =  '#000000';
                this.footerColour = '#000000';
                this.selectedModules = [];
                this.accordionMode = false;
                this.sidebar = '';
                this.layout = false;
                this.icon = null;
                this.logo = null;
                this.isActive = false;
                this.selectedTimezone = 39;

                this.loadingReseller = false;
            },
            ...mapMutations('app', {
                setTitlePage: 'setTitlePage',
            })
        },
        mounted() {
            this.setTitlePage(this.pageTitle);
            this.loadResellerData();
        },
        watch: {
            isUpdateMode(value) {
                if (value) {
                    this.loadResellerData();
                } else {
                    this.clearResellerData();
                }
                this.setTitlePage(this.pageTitle);
            }
        },
    }
</script>

<style lang="scss">

    .icon-wrap {
        width: fit-content;
        height: 150px;
    }

    .logo-wrap {
        width: fit-content;
        height: 150px;
    }

    img{
        max-width:100%;
        max-height:100%;
    }

    .form-title-margin {
        margin: 20px 0 10px 0 !important;
    }

    .checkbox-section{
        display: flex;
        flex-direction: column;
    }

</style>